export const PlusIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
            <path d="M21 9.8623H14.25V3.1123C14.25 2.28402 13.5783 1.6123 12.75 1.6123H11.25C10.4217 1.6123 9.75 2.28402 9.75 3.1123V9.8623H3C2.17172 9.8623 1.5 10.534 1.5 11.3623V12.8623C1.5 13.6906 2.17172 14.3623 3 14.3623H9.75V21.1123C9.75 21.9406 10.4217 22.6123 11.25 22.6123H12.75C13.5783 22.6123 14.25 21.9406 14.25 21.1123V14.3623H21C21.8283 14.3623 22.5 13.6906 22.5 12.8623V11.3623C22.5 10.534 21.8283 9.8623 21 9.8623Z" fill="#FE6F01" />
        </svg>
    )
}